import React, { ReactElement } from 'react';
import CheckboxFormulaire, { PropsDeCheckbox } from './CheckboxFormulaire';

export default function CheckboxFormulaireEtatEntite<T>(props: PropsDeCheckbox<T>): ReactElement {
    return (
        <CheckboxFormulaire
            {...props}
            style={{
                margin: '0px 5px',
                width: 'max-content',
            }}
        />
    );
}
